import type { IconDefinition } from '../index.tsx';

export const iconPlus: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconPlus',
  icon: [16, 16, [], '', 'M10 1H6V6L1 6V10H6V15H10V10H15V6L10 6V1Z'],
};
